import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuditService } from 'src/app/services/audit.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-audit-acknowledgement',
    templateUrl: './audit-acknowledgement.component.html',
    styleUrls: ['./audit-acknowledgement.component.scss'],
    standalone: false
})
export class AuditAcknowledgementComponent {
  userProfileLoaded: boolean = false;
  userProfile?: UserProfile;
  username?: string;
  saving: boolean = false;
  validating:boolean = false;
  pageState: string = "";
  agreeInitials!: FormGroup;
  initialsString: string = '';
  showDoNotAckModal: boolean = false;
  csrDashboardUrl: string = environment.APP_PSP_NEXT_URL + 'csr/customers';
  isCustomerUser: boolean = false;
  isCsr: boolean = false;
  isDriver: boolean = false;

  @ViewChild('DoNotAcknowledgeModal') 
  doNotAcknowledgeModal: TemplateRef<any> | undefined;

  @ViewChild('InitialsInput') initialsInput: ElementRef | undefined;

  constructor(private generalService: GeneralService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private auditService: AuditService,
    public modalService: NgbModal) { }

  ngOnInit(): void {
      const skipAgreedToTerms = (this.authenticationService.getRoles() !== null ? (this.authenticationService.getRoles().includes('csr_admin') || this.authenticationService.getRoles().includes('csr_user')) : false);
      const hasAgreedToTerms = this.authenticationService.getHasAgreedToTerms();
      if (!skipAgreedToTerms && !hasAgreedToTerms) {
          //the only way they should be able to get here is though the change question buttong.
          //there is a check on that to make sure they aggree to terms. if they did not they typed in the route 
          //if they do that.. I just want to kick them out.. they are trying to do something they should not.. so.. good by!
          this.logoff();
      }

      this.username = this.authenticationService.getUserName();
      this.userProfile = this.authenticationService.getUserProfile();
      if (!this.userProfile) {
          this.router.navigateByUrl('/signin');   
      } else if (this.userProfile!.userData.roles.includes("csr_admin") || this.userProfile!.userData.roles.includes("csr_user")) {
          window.location.href = environment.APP_PSP_NEXT_URL + 'csr/customers';
      } else if (this.userProfile!.userData.roles.includes("driver")) {
          this.router.navigateByUrl('/driverDashboard')
      }

      this.agreeInitials = new FormGroup({
            initials: new FormControl(this.initialsString, [
                Validators.required,
                Validators.maxLength(3),
                Validators.minLength(2),
                Validators.pattern(/^([a-zA-Z]*)$/)
            ])
        });
  }

  ngAfterViewInit() {
      window.onbeforeunload = null;
      this.userProfileLoaded = true;
      
      setTimeout(()=>{ // this will make the execution after the above boolean has changed
        this.initialsInput?.nativeElement.focus();
      },3000);  
  }

  get initials() { return this.agreeInitials!.get('initials'); }
  
  get hasErrors(): boolean {
      let hasError = false;
      const letters = /^[A-Za-z]+$/;
      if (this.initials &&
          (this.initials!.value!.length === 2 || this.initials!.value!.length === 3) &&
          this.initials!.value.match(letters)) {
          hasError = false;
      } else {
          hasError = true;
      }
      return hasError;
  }

  logoff() {
      this.authenticationService.logout();
  }

  toDashboard() {
      // skip the must acknowledge condition
      this.authenticationService.setIsAuditAcknowledgeBypassed(true);
      this.router.navigateByUrl('/dashboard');
  }

  acknowledgeAudit() {
      this.saving = true;
      if (this.initials && this.username && this.userProfile && this.userProfile.customerId) {
          const save = this.auditService.acknowledgeAudit(this.userProfile.customerId);
          save.then(() => {
              // set this to resolve the must acknowledge condition
              this.authenticationService.setIsAuditAcknowledged(true);
              this.router.navigateByUrl('/auditDashboard');

          }).catch((error: any) => {
              console.error(error);
              this.router.navigateByUrl('/applicationException');
          });
      }
  }  

  doNotAcknowledgeAudit() {
      this.showDoNotAckModal = true;
      this.modalService.open(this.doNotAcknowledgeModal, { ariaLabelledBy: 'doNotAcknowledgeModalTitle' });
  }

  closeDoNotAcknowledgeAudit() {
      this.showDoNotAckModal = false;
      this.modalService.dismissAll();
      setTimeout(()=>{ // this will make the execution after the above boolean has changed
        this.initialsInput?.nativeElement.focus();
      },1000);  
  }

  getTranslator(val: string): string {
      let translation: string = this.generalService.getTranslation(val, 'base');
      if (translation === undefined) {
          translation = this.generalService.getTranslation(val, 'base');
      }
      return translation;
  }

  pageValid(errors:any): boolean {
      return true;
  }

}
